import Lottie from 'lottie-react';
import alfieWithHeartBubble from '../jsons/alfie_with_heart_bubble.json';
import { ILottieIcon } from '../LottieIcon.types';

const AlfieWithHeartBubble = (props: ILottieIcon) => {
  return <Lottie animationData={alfieWithHeartBubble} {...props} />;
};

export default AlfieWithHeartBubble;
